import { BUILD_ENVIRONMENTS } from '@src/config/constants'

export const YOTPO_CONSTANTS_PROD: Record<string, { guid: string }> = {
  us: {
    guid: 'Ll6pppZ6VQxK_x86N6mnnw',
  },
  ca: {
    guid: '7Z9O-0Ervm9Hh9vB1iT9nA',
  },
}

export const YOTPO_CONSTANTS_TEST: Record<string, { guid: string }> = {
  us: {
    guid: 'OHoPhD5PXj9uYDRxkLP7Qw',
  },
  ca: {
    guid: 'rfB4BfJ5UvqllD9LMAzGAg',
  },
}

export const yotpoSupportedEnvironments = [
  BUILD_ENVIRONMENTS.PROD,
  BUILD_ENVIRONMENTS.QA,
  BUILD_ENVIRONMENTS.STAGE,
  BUILD_ENVIRONMENTS.AUTO_PREVIEW,
]

export const enableYotpoProdEnv = [BUILD_ENVIRONMENTS.PROD, BUILD_ENVIRONMENTS.AUTO_PREVIEW]

// HTTP Headers
export const HTTP_HEADERS = {
  CONTENT_TYPE: 'Content-Type',
  APPLICATION_JSON: 'application/json',
} as const
